import React, { Component } from 'react';
import Grid from '../../Utils/GridFiltro';
import PropTypes from 'prop-types';
import { standardActions } from '../../Utils/GridFiltro/StandardActions';
import NavbarModulo from '../../components/NavbarModulo';

class PresupuestoList extends Component{
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
        onSortChange: PropTypes.func,
    };

    static defaultProps = {
        loading: true
    };

    componentDidMount = () => {
        const { listar, getModulo } = this.props;
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        getModulo(periodo[5],periodo[4]);
        listar();
    }
    render(){
        const { data, loader, periodoD, modulo } = this.props;
        let ruta = window.location.href;
        let datos = ruta.split('/');
        return(
            <React.Fragment>
                <NavbarModulo
                    periodoD = {periodoD}
                    modulo = {modulo}
                />
                <br />
                <h3 className="p-2 bg-secondary title">Mano de obra</h3>
                <br />
                <div className="d-flex flex-row justify-content-start mb-2">
                    <a
                        href={`/#/gestion_proyecto/${datos[5]}/mano_obra/crear`}
                        className='btn btn-primary'
                    >
                        Crear mano de obra
                    </a>
                </div>
                
                <Grid 
                    hover 
                    striped 
                    data={data} 
                    loading={loader} 
                    headerStyle={ { background: 'black' } } 
                    //onPageChange={onPageChange}
                    //onSortChange={onSortChange} 
                >
                    <TableHeaderColumn
                        isKey
                        width="500"
                        dataField="nombreProyecto"
                        dataSort
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Proyecto
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="horasHombre"
                        dataAlign='right'
                        width="200"
                        headerAlign="center"
                        dataSort
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Horas hombre
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="total_quetzales"
                        dataAlign='right'
                        width="200"
                        headerAlign="center"
                        dataSort
                        dataFormat={(cell, row)=>{
                            return new Intl.NumberFormat("en-US",{minimumFractionDigits: 2}).format(cell);
                        }}
                        thStyle={
                            {color: 'white'}}
                        tdStyle={
                            {color: 'white'}}
                    >
                        Monto (Q)
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        thStyle={
                        {color: 'white'}}
                        dataField="id"
                        width="100"
                        dataAlign="center"
                        dataSort
                        dataFormat={standardActions({ 
                            ver: "mano_obra",
                            editar: "mano_obra",
                            empresa: datos[5],
                            periodo: datos[7],
                            modulo: datos[4],
                        })} 
                    >
                        Acciones
                    </TableHeaderColumn>
                </Grid>
            </React.Fragment>
        );
    }
}

export default PresupuestoList;
